import React from "react";

const STAGE_CONTENT = {
  quote: {
    title: "Delivery for your order",
    sub: "Enter your address for an instant price",
    cta: "Get quotations",
    bubble: "Get a delivery price",
    fields: 2,
  },
  priced: {
    title: "Your delivery price",
    sub: "All-in for 3-Seater Couch",
    price: "R 295",
    meta: "1.5 ton · ~32 km",
    cta: "Book delivery",
  },
  payment: {
    title: "Confirm & pay",
    sub: "Secure checkout on QikTruck",
    lines: ["42 Long St, Cape Town", "R 295 delivery"],
    cta: "Pay now",
  },
  confirmed: {
    title: "Booking confirmed",
    sub: "Reference QT-48291",
    badge: "Paid",
  },
  tracking: {
    title: "Driver en route",
    sub: "ETA 45 min",
    progress: 68,
    meta: "Thabo · 1.5 ton bakkie",
  },
};

function ScreenBody({ stage, showBubble }) {
  const data = STAGE_CONTENT[stage] || STAGE_CONTENT.quote;

  return (
    <>
      <div className="qt-phone-brand">QIKTRUCK</div>
      <div className="qt-phone-title">{data.title}</div>
      <div className="qt-phone-sub">{data.sub}</div>

      {data.fields ? (
        <>
          <div className="qt-phone-field" />
          <div className="qt-phone-field qt-phone-field--short" />
        </>
      ) : null}

      {data.price ? (
        <div className="qt-phone-price-block">
          <div className="qt-phone-price">{data.price}</div>
          {data.meta ? <div className="qt-phone-price-meta">{data.meta}</div> : null}
        </div>
      ) : null}

      {data.lines ? (
        <div className="qt-phone-lines">
          {data.lines.map((line) => (
            <div key={line} className="qt-phone-line" />
          ))}
        </div>
      ) : null}

      {data.badge ? (
        <div className="qt-phone-badge">
          <i className="mdi mdi-check-circle" /> {data.badge}
        </div>
      ) : null}

      {typeof data.progress === "number" ? (
        <div className="qt-phone-track">
          <div className="qt-phone-track-bar">
            <div className="qt-phone-track-fill" style={{ width: data.progress + "%" }} />
          </div>
          {data.meta ? <div className="qt-phone-track-meta">{data.meta}</div> : null}
        </div>
      ) : null}

      {data.cta ? <div className="qt-phone-cta">{data.cta}</div> : null}

      {showBubble && data.bubble ? (
        <div className="qt-phone-bubble">
          <i className="mdi mdi-truck" /> {data.bubble}
        </div>
      ) : null}
    </>
  );
}

/**
 * Minimal widget UI preview. Phone frame or bare card to show how little surface area the embed needs.
 */
export function WidgetEmbedMock({
  stage = "quote",
  size = "lg",
  frame = "phone",
  showBubble = false,
  tilt = false,
}) {
  const rootClass = [
    "qt-phone-mock",
    "qt-phone-mock--" + size,
    frame === "card" ? "qt-phone-mock--card" : "",
    tilt ? "qt-phone-mock--tilt" : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (frame === "card") {
    return (
      <div className={rootClass} aria-hidden="true">
        <div className="qt-embed-card">
          <ScreenBody stage={stage} showBubble={showBubble} />
        </div>
      </div>
    );
  }

  return (
    <div className={rootClass} aria-hidden="true">
      <div className="qt-phone-frame">
        <div className="qt-phone-notch" />
        <div className="qt-phone-screen">
          <ScreenBody stage={stage} showBubble={showBubble} />
        </div>
      </div>
    </div>
  );
}

export function EmbedFlowStrip({ stages, size = "xs", frame = "phone", showBubbleOnQuote = false }) {
  return (
    <div className="qt-embed-flow-strip">
      {stages.map((item, idx) => (
        <React.Fragment key={item.id}>
          <div className="qt-embed-flow-strip__item">
            <WidgetEmbedMock
              stage={item.id}
              size={size}
              frame={frame}
              showBubble={showBubbleOnQuote && item.id === "quote"}
            />
            <span className="qt-embed-flow-strip__label">{item.label}</span>
          </div>
          {idx < stages.length - 1 ? (
            <div className="qt-embed-flow-strip__arrow" aria-hidden="true">
              <i className="mdi mdi-chevron-right" />
            </div>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
}

export default WidgetEmbedMock;
